import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  resize() {
    if ($(".js-event-nav").length > 0) {
      var margin = 20;

      const nav = $(".js-event-nav"),
        //ナビの高さ
        navHeight = nav.innerHeight(),
        //ナビゲーションの位置を取得
        navPosition = nav.offset().top - margin,
        //現在のスクロール位置を取得
        scroll = $(window).scrollTop();

      //ナビゲーションの位置までスクロールしたか判定
      if (window.innerWidth < 768 && scroll >= navPosition) {
        const content = $(".js-event-nav-section");

        //コンテンツごとに繰り返し処理
        content.each(function (i, e) {
          //コンテンツの開始位置を取得
          const target = $(this).offset().top - (navHeight + margin),
            //コンテンツの終了位置を取得
            targetPosition = target + $(this).innerHeight(),
            //コンテンツのID属性を取得
            id = $(e).attr("id");

          //該当するコンテンツまでスクロールしているか判定 ＆＆ 該当するコンテンツを通り過ぎたか判定
          if (scroll >= target && scroll < targetPosition) {
            //該当するhref属性にクラスを付与
            nav.find('a[href^="#' + id + '"]').addClass("is-current");
          } else {
            //該当しないhref属性はクラスを削除
            nav.find('a[href^="#' + id + '"]').removeClass("is-current");
          }
        });
      }
    }
  }

  navclick(e) {
    e.preventDefault();
    $.easing.quart = function (x, t, b, c, d) {
      return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    };

    $(".js-event-nav-link").removeClass("is-current");
    $(e.currentTarget).addClass("is-current");

    var speed = 1200,
      href = $(e.currentTarget).attr("href"),
      target = $(href == "#" || href == "" ? "html" : href),
      //クリックの際にカレントが消えないようにナビの下余白よりも少し小さい値を引く
      position = target.offset().top - ($(".js-event-nav").innerHeight() + 18);

    $("html, body").animate(
      {
        scrollTop: position,
      },
      speed,
      "quart",
    );
  }
}
